import { render, staticRenderFns } from "./course_path.vue?vue&type=template&id=4bde4e8d&scoped=true&"
import script from "./course_path.vue?vue&type=script&lang=js&"
export * from "./course_path.vue?vue&type=script&lang=js&"
import style0 from "./course_path.vue?vue&type=style&index=0&id=4bde4e8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bde4e8d",
  null
  
)

export default component.exports